import { Image, Text, View } from "@react-pdf/renderer";
import styles from "./styles";
import { TestQuestionType } from "../types";
import { t } from "i18next";
import renderMarkdownText from "./markdownParseFunction";

type Props = {
  question: TestQuestionType;
  showAnswer: boolean;
  questionIndex: number;
};

export default function TestQuestion({
  question,
  showAnswer,
  questionIndex,
}: Props) {
  const { body, answer, point, options, mediaUrl, image, learningOutcome } =
    question;

  const optionEntries = [];
  for (const [key, value] of Object.entries(options)) {
    optionEntries.push([key, value]);
  }

  let imageFile: string | Buffer | undefined;
  if (image && image.startsWith("data:image")) {
    const base64 = image.split(",")[1];
    const buff = Buffer.from(base64, "base64");
    imageFile = buff;
  } else if (image) {
    imageFile = image;
  } else if (mediaUrl) {
    imageFile = mediaUrl;
  }

  return (
    <View
      style={[styles.questionContainerH, { marginVertical: 4 }]}
      wrap={false}
    >
      <View style={styles.questionContainerV}>
        <Text style={styles.questionNumber}>{`${questionIndex + 1}. `}</Text>
        <View style={styles.questionContainerH}>
          {imageFile && <Image src={imageFile} style={styles.questionImage} />}
          <View style={styles.questionContainerV}>
            <View style={styles.questionBody}>
              <View>
                {renderMarkdownText(
                  body + " (" + point + " " + t("pdf_renderer.point") + ")",
                )}
              </View>
            </View>
          </View>
          <View
            style={[
              styles.questionContainerH,
              { marginTop: 3, marginBottom: 5 },
            ]}
          >
            {optionEntries.map(([id, text]) => (
              <Text
                key={`${question.type}-${questionIndex}-option-${id}`}
                style={[
                  styles.questionBody,
                  { marginVertical: 2 },
                  ...(showAnswer && answer === id ? [styles.answer] : []),
                ]}
              >
                {id}) {renderMarkdownText(text)}
              </Text>
            ))}
          </View>
        </View>
      </View>
      {showAnswer && learningOutcome && (
        <Text style={[styles.answer, styles.questionBody]}>
          {t("pdf_renderer.outcome")}: {renderMarkdownText(learningOutcome)}
        </Text>
      )}
    </View>
  );
}
